$(document).ready(function() {
   
    jQuery(".filter-toggle").on("click" , function(e){
    e.preventDefault();
		jQuery(this).toggleClass("active");
        jQuery(".filter-toggle-wrap").slideToggle("is-visible");
  	})
    var filter = jQuery(this).find('.full_width .sorting_wrapper');
        jQuery(this).find('.filter-toggle').insertBefore(filter);
  
  
   	jQuery('#column-right').insertAfter('#content');
  	jQuery('#shopify-section-footer-style-3,#shopify-section-footer-design-2, #shopify-section-footer-style-1').appendTo('.site-inner');
  	//jQuery('.header_style_3 #shopify-section-TT-mega_menu').insertAfter('.header_style_3 .header-main .header-middle');
  	jQuery('.header_style_2 #shopify-section-TT-mega_menu,.header_style_1 #shopify-section-TT-mega_menu').insertBefore('.menu-bar .topmenu');
  	jQuery('.tt-homeslider').prependTo('.site-inner .main-content');

  	      
  jQuery('.slider-newproduct .product-wrapper').each(function(){
    var prod_desc = jQuery(this).find('.product-description .product-description-wrap');
    jQuery(this).find('.item-row:not(.style3) .btn_wrapper').appendTo(prod_desc);
    
     var prod_desc = jQuery(this).find('.product-description .product-description-wrap .btn_wrapper');
    jQuery(this).find('.flip-countdown.simple-countdown').insertBefore(prod_desc);
     
     var prod_desc = jQuery(this).find('.product-description .product-description-wrap');
    jQuery(this).find('.grid-view-item__title').prependTo(prod_desc);
     
      var prod_desc = jQuery(this).find('.product-description .flip-countdown.simple-countdown');
    jQuery(this).find('.ttqtyprogress').insertBefore(prod_desc);
     
     var prod_clr = jQuery(this).find('.product-description .grid-view-item__meta');
        jQuery(this).find('.color_swatch_Value').insertAfter(prod_clr);

  });
  jQuery("body.left_sidebar #tt-megamenu .tt-mega_menu ul>li,body.both_sidebar #tt-megamenu .tt-mega_menu ul>li,body.right_sidebar #tt-megamenu .tt-mega_menu ul>li").hover(
    function () {
      jQuery("body").addClass("menu_hover");
    },
    function () {
      jQuery("body").removeClass("menu_hover");
    }
  );
  jQuery('.slider-bestproduct .product-wrapper').each(function(){
    var prod_desc = jQuery(this).find('.product-description .product-description-wrap .btn_wrapper');
    jQuery(this).find('.flip-countdown.simple-countdown').insertBefore(prod_desc);

  });	
  jQuery('.template-index .category-slider .nav-tabs').on('click', 'li.tabs > a', function() {
    /*
      Las tabs de categoria están dentro de Owl Carousel y Bootstrap no siempre limpia bien
      el estado `.active` en todos los items. Si dejamos que se acumulen, se ven varios
      marcadores activos a la vez.

      Importante: no marcar `.active` manualmente en el <li> antes de que Bootstrap procese
      `data-toggle="tab"`, porque puede impedir el cambio de contenido. Aqui solo limpiamos
      el estado visual del <a>; Bootstrap se encarga del pane/tab real.
    */
    var $nav = jQuery(this).closest('ul.nav-tabs');
    $nav.find('li.tabs.active').removeClass('active');
    $nav.find('a.active').removeClass('active');
    jQuery(this).addClass('active');
  });
  
    
  jQuery('#tt-megamenu span.toggle_menu').click(function(event) {
    jQuery(this).toggleClass('active');
    $('body').toggleClass("menu-current-open");
    jQuery("body.no_sidebar .page-wrapper").toggleClass("menu_hover");
    event.stopPropagation();

    // Desktop keeps the legacy slide animation. On mobile, CSS handles the drawer via body.menu-current-open.
    if (jQuery(window).width() >= 992) {
      jQuery('.tt-mega-menu #tt-megamenu .tt-mega_menu').slideToggle("2000");
    }
    
  });
  
  jQuery(".tt-mega-menu #tt-megamenu .tt-mega_menu").on("click", function(event) {
    event.stopPropagation();
  });

  function closeMobileCategoryDrawer() {
    jQuery('#tt-megamenu span.toggle_menu').removeClass('active');
    jQuery('body').removeClass('menu-current-open');
    jQuery("body.no_sidebar .page-wrapper").removeClass("menu_hover");

    // Keep desktop behavior consistent if this runs on large screens.
    if (jQuery(window).width() >= 992) {
      jQuery('.tt-mega-menu #tt-megamenu .tt-mega_menu').stop(true, true).slideUp("fast");
    }
  }

  // Cierra el menú de categorías al hacer clic fuera (mobile + desktop).
  // Importante: no cerrar si el clic fue dentro del menú (submenús, links, etc).
  jQuery(document).on('click', function(e) {
    if (!jQuery('body').hasClass('menu-current-open')) return;

    var $target = jQuery(e.target);
    if ($target.closest('#tt-megamenu').length) return;

    closeMobileCategoryDrawer();
  });

  // ESC cierra el menú de categorías.
  jQuery(document).on('keyup', function(e) {
    if (e.key === 'Escape' && jQuery('body').hasClass('menu-current-open')) {
      closeMobileCategoryDrawer();
    }
  });
  
  var w_width = $(window).width();
  $('.slider-content-main-wrap').css('width',w_width);
  if($('.site-header').hasClass('header_transaparent')){
  	$('body.template-index').addClass('header_transaparent')
  }
  
  // $(".wrapper-wrap.fullscreen_header .fullscreen_wrapper").perfectScrollbar();
  $(".fixed .mini-cart-wrap").perfectScrollbar();
  
  var img_id = jQuery('.product-single__thumbs .slick-active.slick-current').find('.product-single__thumb').data('id');
  if(jQuery('.product-lightbox-btn').hasClass(img_id)){
    jQuery('.product-lightbox-btn.'+img_id).show();
  }
  
  var p = jQuery(".popup_overlay");

  jQuery(".play-icone").click(function() {
    jQuery("body").addClass("popup-toggle");
    p.css("display", "block");

  });
  p.click(function(event) {
    e = event || window.event;
    if (e.target == this) {
      jQuery(p).css("display", "none");
      jQuery('body').removeClass('popup-toggle'); 
    }
  });
  jQuery(".popup_close,.flex-direction-nav li a").click(function() {
    p.css("display", "none");
    jQuery('body').removeClass('popup-toggle'); 
  });

  //video popup
  function toggleVideo(state) {
    // if state == 'hide', hide. Else: show video
    e = state || window.event;
    if (e.target == this) {
      var div = document.getElementById("popupVid");
      var iframe = div.getElementsByTagName("iframe")[0].contentWindow;
      //div.style.display = state == 'hide' ? 'none' : '';
      func = state == "hide" ? "pauseVideo" : "playVideo";
      iframe.postMessage(
        '{"event":"command","func":"' + func + '","args":""}',
        "*"
      );
    }
  }

  jQuery("#popup_toggle").click(function() {
    p.css("visibility", "visible").css("opacity", "1");
  });

  p.click(function(event) {
    e = event || window.event;
    if (e.target == this) {
      jQuery(p)
      .css("visibility", "hidden")
      .css("opacity", "0");
      toggleVideo("hide");
    }
  });

  jQuery(".popup_close,.flex-direction-nav li a").click(function() {
    p.css("visibility", "hidden").css("opacity", "0");
    toggleVideo("hide");
  });
  
  var iframe = jQuery("iframe")[0];
  
  
 jQuery(".filter-left").on("click" , function(e){
    e.preventDefault();
		jQuery(this).toggleClass("active");
		jQuery(".off-canvas.position-left").toggleClass("is-open");
        jQuery(".js-off-canvas-overlay.is-overlay-fixed").toggleClass("is-visible is-closable");
  	});
   jQuery(".is-overlay-fixed").on("click" , function(e){
    e.preventDefault();
     jQuery(".filter-left").trigger('click');
      jQuery(".filter-right").trigger('click');
   });
  jQuery(".filter-right").on("click" , function(e){
    e.preventDefault();
		jQuery(this).toggleClass("active");
		jQuery(".off-canvas.position-right").toggleClass("is-open");
        jQuery(".js-off-canvas-overlay.is-overlay-fixed").toggleClass("is-visible is-closable");
  	});
   $('.product-360-button a').magnificPopup({
       type: 'inline',
       mainClass: 'mfp-fade',
       removalDelay: 160,
       disableOn: false,
       preloader: false,
       fixedContentPos: false,
       callbacks: {
         open: function() {
           $(window).resize()
         }
       }
   });

  
  
 /* coundown js */
  //countDownProductIni('.js-flip-countdown');
  /* simple countdown */
   countDownIni('.flip-countdown,.js-flip-countdown'); 
  /***/
  /** popup Video **/
  
   $('.popup-video').magnificPopup({
        disableOn: 300,
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
    });
  
  /***/
  
 if ($('a.product-lightbox-btn').length > 0 || $('a.product-video-popup').length > 0) {
         $('.product-single__photos .gallery,.design_2 .product-img').magnificPopup({
        delegate: 'a', // child items selector, by clicking on it popup will open
        type: 'image',
            tLoading: '<div class="please-wait dark"><span></span><span></span><span></span></div>',
            removalDelay: 300,
            closeOnContentClick: true,
            gallery: {
                enabled: true,
                navigateByImgClick: false,
                preload: [0, 1]
            },
            image: {
                verticalFit: false,
                tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
            },
            callbacks: {
                beforeOpen: function() {
                    var productVideo = $('.product-video-popup').attr('href');
                    if (productVideo) {
                        this.st.mainClass = 'has-product-video';
                        var galeryPopup = $.magnificPopup.instance;
                        galeryPopup.items.push({
                            src: productVideo,
                            type: 'iframe'
                        });
                        galeryPopup.updateItemHTML();
                    }
                },
                open: function() {}
            }
        // other options
      });
 }
    $('.design_3 .product-img,.design_5 .pro_img').magnificPopup({
        delegate: 'a', // child items selector, by clicking on it popup will open
        type: 'image',
            tLoading: '<div class="please-wait dark"><span></span><span></span><span></span></div>',
            removalDelay: 300,
            closeOnContentClick: true,
            gallery: {
                enabled: true,
                navigateByImgClick: false,
                preload: [0, 1]
            },
            image: {
                verticalFit: false,
                tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
            },
            callbacks: {
                beforeOpen: function() {
                    var productVideo = $('.product-video-popup').attr('href');
                    if (productVideo) {
                        this.st.mainClass = 'has-product-video';
                        var galeryPopup = $.magnificPopup.instance;
                        galeryPopup.items.push({
                            src: productVideo,
                            type: 'iframe'
                        });
                        galeryPopup.updateItemHTML();
                    }
                },
                open: function() {}
            }
        // other options
      });
        $('body').on('click', '.product-lightbox-btn', function(e) {
            $('.product-wrapper-owlslider').find('.owl-item.active a').click();
            e.preventDefault();
        });
 
  
    /* start vertical js*/	
  if(jQuery(".leftmenu_header").length > 0){
    if(jQuery(".leftmenu_header_fixed.leftmenu_header").length > 0){
    	if(jQuery(".leftmenu_header_fixed.leftmenu_header").hasClass('menu_left')){
        jQuery("body").addClass("menu_left");
      } 
      	if(jQuery(".leftmenu_header_fixed.leftmenu_header").hasClass('menu_right')){
          jQuery("body").addClass("menu_right");
    	}
    }
	jQuery(".leftmenu_header").on("click" , function(e){
      e.preventDefault();
		jQuery(this).toggleClass("active");
		jQuery("body").toggleClass("nav-open");
  	});
      
  }
  
	/* end vertical js*/
  
   $('.qtyplus').on('click',function(e){
    e.preventDefault();     
      var  input_val = jQuery(this).parents('.qty-box-set').find('.quantity');
      var currentVal = parseInt( jQuery(this).parents('.qty-box-set').find('.quantity').val());
      if (!isNaN(currentVal)) {
        jQuery(this).parents('.qty-box-set').find('.quantity').val(currentVal + 1);
      } else {
        jQuery(this).parents('.qty-box-set').find('.quantity').val(1);
      }

  });

  $(".qtyminus").on('click',function(e) {
    e.preventDefault();
    var  input_val = jQuery(this).parents('.qty-box-set').find('.quantity');
    var currentVal = parseInt( jQuery(this).parents('.qty-box-set').find('.quantity').val());
    if (!isNaN(currentVal) && currentVal > 1) {
      jQuery(this).parents('.qty-box-set').find('.quantity').val(currentVal - 1);
    } else {
      jQuery(this).parents('.qty-box-set').find('.quantity').val(1);
    }

  });
   $("#navToggle").on('click',function(e) {
     jQuery(this).next('.Site-navigation').slideToggle(500);
   });
  $(".menu_toggle_wrap #navToggle").on('click',function(e) {
     jQuery(this).parent().next('.Site-navigation').slideToggle(500);
   });
  
  
 /*Scroll to top js*/
    jQuery("#GotoTop").on('click',function () {
        jQuery("html, body").animate({
            scrollTop: 0
        }, '1000');
        return false;
    });
  
    jQuery(".site-header__search.search-full .serach_icon").on('click',function(e){
     e.preventDefault();
    	jQuery(this).toggleClass('active'); 
        jQuery('body').toggleClass('search_full_active'); 
        jQuery('.full-search-wrapper').addClass('search-overlap');
        jQuery(".search-bar > input").focus();
    });
  jQuery(".site-header__search.search-full .close-search").on('click',function(){
     jQuery('.site-header__search.search-full .serach_icon').removeClass('active');   
    jQuery('.full-search-wrapper').removeClass('search-overlap');   
    jQuery('body').removeClass('search_full_active'); 
    });
  
  jQuery(".site-header__search:not(.search-full) .serach_icon").on('click', function() {
    jQuery(".search_wrapper").slideToggle("fast");
    jQuery(".search-bar > input").focus();
    jQuery(this).toggleClass('active');
    jQuery(".customer_account").slideUp("fast");
    jQuery('body').removeClass('currency-open');
    jQuery('body').removeClass('language-open');
    jQuery('body').removeClass('myaccount_active');
    jQuery("#slidedown-cart").slideUp("fast");
    jQuery("#Sticky-slidedown-cart").slideUp("fast")
  });
  jQuery(".myaccount  .dropdown-toggle").on('click', function(event) {
    event.preventDefault();
    event.stopPropagation();
    jQuery(".customer_account").slideToggle("fast");
    jQuery('.site-header__search:not(.search-full) .serach_icon').removeClass('active');
    jQuery('body').removeClass('search_full_active');
    jQuery('.site-header_cart_link').removeClass('active');
    jQuery(".site-header .search_wrapper").slideUp("fast");
    jQuery('body').toggleClass('myaccount_active');
    jQuery('body').removeClass('cart_active');
    jQuery('body').removeClass('currency-open');
    jQuery('body').removeClass('language-open');
    jQuery("#slidedown-cart").slideUp("fast");
    jQuery("#Sticky-slidedown-cart").slideUp("fast")
  });
  jQuery(document).off('click.myaccount').on('click.myaccount', function(event) {
    if (!jQuery(event.target).closest('.myaccount').length) {
      jQuery(".customer_account").slideUp("fast");
      jQuery('body').removeClass('myaccount_active');
    }
  });
  jQuery(document).off('keyup.myaccount').on('keyup.myaccount', function(event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      jQuery(".customer_account").slideUp("fast");
      jQuery('body').removeClass('myaccount_active');
    }
  });
   $(".header_currency .currency_wrapper.dropdown-toggle").on("click", function(event) {
    event.preventDefault();
    jQuery(".customer_account").stop();
    jQuery(".currencies.flag-dropdown-menu").slideToggle("fast");
    $(this).toggleClass('active');
    jQuery('body').toggleClass('currency-open');    
    jQuery('body').removeClass('language-open');
    jQuery('body').removeClass('myaccount_active');
    jQuery('body').removeClass('cart_active');
    jQuery( ".language.flag-dropdown-menu" ).slideUp( "fast" );
    jQuery("#slidedown-cart").slideUp("fast");
    jQuery("#Sticky-slidedown-cart").slideUp("fast");
    jQuery( ".customer_account" ).slideUp( "fast" );
    $(".header_language .language-block .language_wrapper.dropdown-toggle").removeClass('active');
  });
  /*---------------- Language ---------------*/
  $(".header_language .language-block .language_wrapper.dropdown-toggle").on("click", function (event) {     
    event.preventDefault();
    jQuery(".customer_account").stop();      
    jQuery( ".language.flag-dropdown-menu" ).slideToggle( "fast" );
    $(this).toggleClass('active');  
    jQuery('body').toggleClass('language-open');
    jQuery('body').removeClass('cart_active');
    jQuery('body').removeClass('currency-open');
    jQuery('body').removeClass('myaccount_active');
    jQuery( ".currencies.flag-dropdown-menu" ).slideUp( "fast" );
    jQuery("#slidedown-cart").slideUp("fast");
    jQuery("#Sticky-slidedown-cart").slideUp("fast");
    jQuery( ".customer_account" ).slideUp( "fast" );
    $(".header_currency .currency_wrapper.dropdown-toggle").removeClass('active');
  });
  var p_col = jQuery('.slider-newproduct').data('col');
  if(jQuery("body:not(.rtl)").hasClass('left_sidebar')){
  $('body.left_sidebar:not(.rtl) .slider-newproduct').owlCarousel({
              items : p_col, //10 items above 1000px browser width
              nav : true,
    		  autoplay:true,
              autoplaySpeed:1500,
    		autoplayHoverPause: true,
              dots : false,
            	responsive: {
                  100: {
                    items: 1
                  },
                  543: {
                    items: 1
                  },
                  768: {
                    items: 1
                  },
                  992: {
                    items: 1
                  },
                   1200: {
                    items: 2
                  },
                   1600: {
                    items: 2
                  },
                  	1700: {
                      items: p_col
                    }
                }
   });
  }else{
     $('body:not(.rtl.left_sidebar) .slider-newproduct').owlCarousel({
              items : p_col, //10 items above 1000px browser width
              nav : true,
              dots : false,
       		  autoplay:true,
              autoplaySpeed:1500,
       			autoplayHoverPause: true,
            	responsive: {
                  100: {
                    items: 1
                  },
                  543: {
                    items: 1
                  },
                  768: {
                    items: 1
                  },
                  992: {
                    items: 1
                  },
                   1200: {
                    items: 2
                  },
                   1600: {
                    items: 2
                  },
                  	1700: {
                      items: p_col
                    }
                }
   });
  }  
   
  if(jQuery("body.rtl.left_sidebar").hasClass('left_sidebar')){
  $('body.rtl.left_sidebar .slider-newproduct').owlCarousel({
              items : p_col, //10 items above 1000px browser width
              nav : true,
              dots : false,
    		  autoplay:true,
              autoplaySpeed:1500,
    		autoplayHoverPause: true,
               rtl:true,
            	responsive: {
                  100: {
                    items: 1
                  },
                  543: {
                    items: 1
                  },
                  768: {
                    items: 1
                  },
                  992: {
                    items: 1
                  },
                   1200: {
                    items: 2
                  },
                   1600: {
                    items: 2
                  },
                  	1700: {
                      items: p_col
                    }
                }
          });
  }else{
    
     $('body.rtl:not(.left_sidebar) .slider-newproduct').owlCarousel({
              items : p_col, //10 items above 1000px browser width
              nav : true,
              dots : false,
       		  autoplay:true,
              autoplaySpeed:1500,
       		autoplayHoverPause: true,
               rtl:true,
            	responsive: {
                  100: {
                    items: 1
                  },
                  543: {
                    items: 1
                  },
                  768: {
                    items: 1
                  },
                  992: {
                    items: 1
                  },
                   1200: {
                    items: 2
                  },
                   1600: {
                    items: 2
                  },
                  	1700: {
                      items: p_col
                    }
                }
          });
  }
  
  			$('.slider-newproduct-wrap').each(function () { 
              if($(this).find('.owl-nav').hasClass('disabled')){
                $(this).find('.customNavigation').hide();
              }else{
                $(this).find('.customNavigation').show();
              }
            });
          $(".slider-newproduct-wrap .customNavigation .next").click(function(){
				var wrap = $(this).closest('.slider-newproduct-wrap');
              $(wrap).find('.slider-newproduct').trigger('next.owl');
          });
          $(".slider-newproduct-wrap .customNavigation .prev").click(function(){
			var wrap = $(this).closest('.slider-newproduct-wrap');
               $(wrap).find('.slider-newproduct').trigger('prev.owl');
          });
  
    /*      $('.mobile-nav__sublist-trigger').on('click', function(evt) {
            evt.preventDefault();
              var $el = $(this);
             $el.toggleClass('is-active');
                $el.parent().find('.tt_sub_menu_wrap').slideToggle(200);
          });*/
  
 
  		/*$(".Site-navigation .header-icons-wrap").append($(".menu_toggle_wrap"));*/
          $('.product-wrapper').each(function(){                                                            
              var $desc = $(this).find('.product-description .progress');
              var $qty = $(this).find('.quantity');
              var $pbar = $(this).find('.progress-bar');
              var $progress = $desc;
              var $progressBar = $pbar;
              var $quantity = $qty.html();
              var currentWidth = parseInt($progressBar.css('width'));
              var allowedWidth = parseInt($progress.css('width'));
              var addedWidth = currentWidth + parseInt($quantity);
              if (addedWidth > allowedWidth) {
                addedWidth = allowedWidth;
              }
              var progress = (addedWidth / allowedWidth) * 100;
              $progressBar.animate({width: progress + '%' }, 100);
            });  
   
  
      var p_col = jQuery('.slider-bestproduct').data('col');
      $('body:not(.rtl) .slider-bestproduct').owlCarousel({
                  items : p_col, //10 items above 1000px browser width
                  nav : true,
                  autoplay:true,
                  autoplaySpeed:1500,	
                  dots : false,
                    responsive: {
                      100: {
                        items: 1
                      },
                      681: {
                        items: 2
                      },
                      768: {
                        items: 2
                      },
                      992: {
                        items:2
                      },
                       1200: {
                        items: 3
                      },
                       1460: {
                        items: 4
                      },
                        1700: {
                          items: p_col
                        }
                    }
       });
        
         $('body.rtl .slider-bestproduct').owlCarousel({
                  items : p_col, //10 items above 1000px browser width
                  nav : true,
                  dots : false,
                  autoplay:true,
                  autoplaySpeed:1500,	
                    responsive: {
                      100: {
                        items: 1
                      },
                      681: {
                        items: 2
                      },
                      768: {
                        items: 2
                      },
                      992: {
                        items: 2
                      },
                       1200: {
                        items: 3
                      },
                       1460: {
                        items: 4
                      },
                        1700: {
                          items: p_col
                        }
                    }
       });
        

                $('.slider-bestproduct-wrap').each(function () { 
                  if($(this).find('.owl-nav').hasClass('disabled')){
                    $(this).find('.customNavigation').hide();
                  }else{
                    $(this).find('.customNavigation').show();
                  }
                });
              $(".slider-bestproduct-wrap .customNavigation .next").click(function(){
                    var wrap = $(this).closest('.slider-bestproduct-wrap');
                  $(wrap).find('.slider-bestproduct').trigger('next.owl');
              });
              $(".slider-bestproduct-wrap .customNavigation .prev").click(function(){
                var wrap = $(this).closest('.slider-bestproduct-wrap');
                   $(wrap).find('.slider-bestproduct').trigger('prev.owl');
              });
  
  		$('body:not(.rtl) .slider-megadeals-wrap .slider-megadeals').owlCarousel({
              items : 1, //1 items above 1000px browser width
              nav : true,
              dots : false,
              loop: true,
			  autoplay:false,
			  rtl:false,
              responsive: {
                      1279: {
                        items: 1
                      },
                      1250: {
                        items: 1
                      },
                      600: {
                        items: 1
                      }
                    }
          });
		$('body.rtl .slider-megadeals-wrap .slider-megadeals').owlCarousel({
              items : 1, //1 items above 1000px browser width
              nav : true,
              dots : false,
              loop: true,
			  autoplay:false,				
			  rtl:true,
              responsive: {
                      1279: {
                        items: 1
                      },
                      1250: {
                        items: 1
                      },
                      600: {
                        items: 1
                      }
                    }
          });
  	
  
  		 $('body:not(.rtl) .cms-footer .services').owlCarousel({
              items :3, //1 items above 1000px browser width
              nav : true,
              dots : true,
              loop: false,
			  autoplay:true,
			  rtl:false,
              responsive: {
                      1430: {
                        items: 3
                      },
					  1200: {
                        items: 3
                      },
					992: {
                        items: 3
                      },
					768: {
                        items: 2
                      },
                      100: {
                        items:2
                      }
                    }
          });
		$('body.rtl .cms-footer .services').owlCarousel({
              items : 3, //1 items above 1000px browser width
              nav : true,
              dots : true,
              loop: false,
			  autoplay:true,				
			  rtl:true,
              responsive: {
                      1430: {
                        items: 3
                      },
					  1200: {
                        items: 3
                      },
						992: {
                        items: 3
                      },
					768: {
                        items: 2
                      },
                      100: {
                        items: 2
                      }
                    }
          });
  $('body .header_service').owlCarousel({
              items : 1, //1 items above 1000px browser width
              nav : false,
				dots : false,
				loop: true,
				autoplay:true,	
				rtl:false,
				autoplaySpeed: 1000,
				autoplayHoverPause:true,
				smartSpeed:450,
				animateIn: 'fadeIn',
				animateOut: 'fadeOut',
              responsive: {
                      1430: {
                        items: 1
                      },
					 
					768: {
                        items: 1
                      },
                      100: {
                        items: 1
                      }
                    }
          });
  
  		$('body:not(.rtl) .collection-desc-wrap .cat-banner').owlCarousel({
              items : 1, //1 items above 1000px browser width
              nav : false,
              dots : true,
              loop: false,
			  autoplay:false,
			  rtl:false,
              responsive: {
                      1279: {
                        items: 1
                      },
                      1250: {
                        items: 1
                      },
                      600: {
                        items: 1
                      }
                    }
          });
  			$('body.rtl .collection-desc-wrap .cat-banner').owlCarousel({
              items : 1, //1 items above 1000px browser width
              nav : false,
              dots : true,
              loop: false,
			  autoplay:false,
			  rtl:true,
              responsive: {
                      1279: {
                        items: 1
                      },
                      1250: {
                        items: 1
                      },
                      600: {
                        items: 1
                      }
                    }
          });


  
  			$('body:not(.rtl) .widget_top_rated_products .top-products').owlCarousel({
              items : 1, //1 items above 1000px browser width
              nav : true,
              dots : true,
              loop: true,
			  autoplay:true,
			  rtl:false,
              responsive: {
                      1279: {
                        items: 1
                      },
                      1250: {
                        items: 1
                      },
                      600: {
                        items: 1
                      }
                    }
          });
		$('body.rtl .widget_top_rated_products .top-products').owlCarousel({
              items : 1, //1 items above 1000px browser width
              nav : true,
              dots : true,
              loop: true,
			  autoplay:true,				
			  rtl:true,
              responsive: {
                      1279: {
                        items: 1
                      },
                      1250: {
                        items: 1
                      },
                      600: {
                        items: 1
                      }
                    }
          });
		
  			$('body:not(.rtl) .testimonials_wrap').owlCarousel({
              items : 1, //1 items above 1000px browser width
              nav : false,
              dots : true,
              loop: false,
			  autoplay:true,
			  rtl:false,
              responsive: {
                      1279: {
                        items: 1
                      },
                      1250: {
                        items: 1
                      },
                      600: {
                        items: 1
                      }
                    }
          });
		$('body.rtl .testimonials_wrap').owlCarousel({
              items : 1, //1 items above 1000px browser width
              nav : false,
              dots : true,
              loop: false,
			  autoplay:true,				
			  rtl:true,
              responsive: {
                      1279: {
                        items: 1
                      },
                      1250: {
                        items: 1
                      },
                      600: {
                        items: 1
                      }
                    }
          });
  		
  		$('body:not(.rtl) .category-slider .tthometab-title .nav.nav-tabs').owlCarousel({
              items : 6, //1 items above 1000px browser width
              nav : false,
              dots : false,
              loop: false,
			  autoplay:false,
          	  autoplayTimeout:5000,
			  rtl:false,
              responsive: {
                      1279: {
                        items: 6
                      },
                      1250: {
                        items: 5
                      },
                      700: {
                        items: 4
                      },
                		552: {
                        items: 3
                      },
                		360: {
                        items: 2
                      },
                		100: {
                        items: 2
                      }
                    }
          });
		$('body.rtl .category-slider .tthometab-title .nav.nav-tabs').owlCarousel({
              items : 6, //1 items above 1000px browser width
              nav : false,
              dots : true,
              loop: false,
			  autoplay:false,
          	  autoplayTimeout:5000,
          		rewindNav:true,
			  rtl:true,
              responsive: {
                      1279: {
                        items:6
                      },
                      1250: {
                        items: 5
                      },
                      700: {
                        items: 4
                      },
                		552: {
                        items: 3
                      },
                		360: {
                        items: 2
                      },
                		100: {
                        items: 2
                      }
                    }
          });
  	
  		$('body:not(.rtl) #ttcmsservices .block_content').owlCarousel({
              items :5, //1 items above 1000px browser width
              nav : true,
              dots : true,
              loop: true,
			  autoplay:true,
          		rewindNav:true,
			  rtl:false,
              responsive: {
                      1279: {
                        items: 5
                      },
					  992: {
                        items: 4
                      },
					  481: {
                        items: 3
                      },
                      100: {
                        items: 2
                      }
                    }
          });
		$('body.rtl #ttcmsservices .block_content').owlCarousel({
              items : 5, //1 items above 1000px browser width
              nav : true,
              dots : true,
              loop: true,
			  autoplay:true,				
			  rtl:true,
              responsive: {
                      1279: {
                        items: 5
                      },
					  992: {
                        items: 4
                      },
					  481: {
                        items: 3
                      },
                      100: {
                        items: 2
                      }
                    }
          });
  
  		$(".dt-menu-expand").click(function(event){
        event.preventDefault();
        if($(this).hasClass("dt-mean-clicked")){
        $(this).text("+");
        if( $(this).prev('ul').length ) {
        $(this).prev('ul').slideUp(400);
        } else {
        $(this).prev('.megamenu-child-container').find('ul:first').slideUp(600);
        }
        } else {
        $(this).text("-");
        if( $(this).prev('ul').length ) {
        $(this).prev('ul').slideDown(400);
        } else{
        $(this).prev('.megamenu-child-container').find('ul:first').slideDown(2000);
        }
        }

        $(this).toggleClass("dt-mean-clicked");
        return false;
        });
  
  		 $('body:not(.rtl) .ttleft-testimonial-wrap .testimonials_wrap').owlCarousel({
              items : 1, //1 items above 1000px browser width
              nav : true,
              dots : true,
              loop: false,
			  autoplay:true,
			  rtl:false,
              responsive: {
                      1279: {
                        items: 1
                      },
                      1250: {
                        items: 1
                      },
                      600: {
                        items: 1
                      }
                    }
          });
		$('body.rtl .ttleft-testimonial-wrap .testimonials_wrap').owlCarousel({
              items : 1, //1 items above 1000px browser width
              nav : true,
              dots : true,
              loop: false,
			  autoplay:true,				
			  rtl:true,
              responsive: {
                      1279: {
                        items: 1
                      },
                      1250: {
                        items: 1
                      },
                      600: {
                        items: 1
                      }
                    }
          });
  
   $(".full_gallery_slider.owl-carousel").on("changed.owl.carousel",function(e){
    console.log(e);
    var element = e.target; // DOM element, in this example .owl-carousel
    var items = e.item.count; // Number of items
    var item = e.relatedTarget.relative(e.item.index) + 1; 

    console.log(e.relatedTarget.relative);

    $(element).parent().find('.num').html(item + "/" + items)
  }),

    $('body:not(.rtl) .full_gallery_slider.owl-carousel').owlCarousel({
    stagePadding: 200,
    loop:true,
    startPosition:0,
    center: true,
    dots:true,
    items:2,
    lazyLoad: true,
    nav:false,
    responsive:{
      0:{
        items:1,
        stagePadding: 60
      },
      600:{
        items:1,
        stagePadding: 150
      },
      768:{
        items:1,
        stagePadding: 180
      },
      868:{
        items:1,
        stagePadding: 250
      },
      1800:{
        items:2,
        stagePadding: 300
      }
    }
  });
  $('body.rtl .full_gallery_slider.owl-carousel').owlCarousel({
    stagePadding: 200,
    loop:true,
    startPosition:0,
    center: true,
    dots:true,
    items:2,
    rtl:true,
    lazyLoad: true,
    nav:false,
    responsive:{
      0:{
        items:1,
        stagePadding: 60
      },
      600:{
        items:1,
        stagePadding: 150
      },
      768:{
        items:1,
        stagePadding: 180
      },
      868:{
        items:1,
        stagePadding: 250
      },
      1800:{
        items:2,
        stagePadding: 300
      }
    }
  });
  
  		$('body:not(.rtl) #tt-megamenu .list_product_menu_content').owlCarousel({
              items : 3, //1 items above 1000px browser width
              nav : true,
    		  autoPlay:true,
              autoplaySpeed:1000,
              stopOnHover: false,
              loop: false,
              dots : true,
              responsive: {
                      992: {
                        items: 3
                      },
                      481: {
                        items: 2
                      },
                      100: {
                        items: 1
                      }
                    }
          });
 		$('body.rtl #tt-megamenu .list_product_menu_content').owlCarousel({
            items : 3, //1 items above 1000px browser width
            nav : true,
            autoPlay:true,
            autoplaySpeed:1000,
            rtl: true,
            stopOnHover: false,
            loop: false,
            dots : true,
            responsive: {
                      992: {
                        items: 3
                      },
                      481: {
                        items: 2
                      },
                      100: {
                        items: 1
                      }
                    }
          });
  
  		$('body:not(.rtl) .collection_cms_slider').owlCarousel({             
          nav : true,
          dots : false,
          autoplay:true,
          autoplaySpeed:1500,
          loop: false,
           responsive: {
            100: {
              items: 1
            },
			370: {
              items: 2
            },
            555: {
              items: 3
            },
			 992: {
              items: 4
            },
            1200: {
              items: 5
            },
			1260: {
              items: 5
            },
            1460: {
              items: 6
            }
          }
          });
        $('body.rtl .collection_cms_slider').owlCarousel({
          nav : true,
          rtl:true,
          loop: false,
          autoplay:true,
          autoplaySpeed:1500,
          dots : false,
           responsive: {
            100: {
              items: 1
            },
			370: {
              items: 2
            },
            555: {
              items: 3
            },
			 992: {
              items: 4
            },
            1200: {
              items: 5
            },
			1260: {
              items: 5
            },
            1460: {
              items: 6
            }
          }
          });
  

    if(jQuery(".collection_cms_slider .owl-nav").hasClass('disabled')){
     jQuery(".collection_cms_slider_wrap .customNavigation").hide();
    }else{
     jQuery(".collection_cms_slider_wrap .customNavigation").show();
    }
       jQuery(".collection_cms_slider_wrap .customNavigation .next").click(function(){
        jQuery('.collection_cms_slider_wrap .collection_cms_slider').trigger('next.owl');
      });
      jQuery(".collection_cms_slider_wrap .customNavigation .prev").click(function(){
        jQuery('.collection_cms_slider_wrap .collection_cms_slider').trigger('prev.owl');
      }); 
  
  		var blogowlrtl = $("body.rtl .grid-blog-slider");
        $("body.rtl .grid-blog-slider").owlCarousel({
        items : 4 , //10 items above 1000px browser width
        loop: false,
        nav: true,  
          rtl: true, 
          	autoplayHoverPause: true,
		dots: false,
        responsive: {
          100: {
            items: 1
          },
          543: {
            items: 2
          },
          992: {
            items: 3
          },
          1200: {
            items: 3
          },
          1460: {
            items:4
          }
        }
         });

   var blogowl = $("body:not(.rtl) .grid-blog-slider");
     $("body:not(.rtl) .grid-blog-slider").owlCarousel({
        items : 4 , //10 items above 1000px browser width
        loop: false,
        nav: true,  
        rtl: false,  
		dots: false,
       autoplayHoverPause: true,
        responsive: {
          100: {
            items: 1
          },
          543: {
            items: 2
          },
          992: {
            items: 3
          },
           1200: {
            items: 3
          },
          1460: {
            items: 4
          }
        }
         });
      $('.grid--blog').each(function () { 
              if($(this).find('.owl-nav').hasClass('disabled')){
                $(this).find('.customNavigation').hide();
              }else{
                $(this).find('.customNavigation').show();
              }
            });
    $(".blog_next").click(function(){
    	 $(".grid-blog-slider").trigger('next.owl');
    });
    $(".blog_prev").click(function(){
    	 $(".grid-blog-slider").trigger('prev.owl');
    });
  
  	var brandsowl = $("body:not(.rtl) #brands_list_slider");
     var  brandsowlrtl = $("body.rtl #brands_list_slider");
     brandsowl.owlCarousel({
        items : 6 , //10 items above 1000px browser width
		dots: false,
        loop: false,
      	autoplay:true,
        autoplaySpeed:1500,
       	autoplayHoverPause: true,
		nav: true,
		responsive: {
          320: {
            items: 2
          },
          544: {
            items: 3
          },
          992: {
            items: 4
          },
        	1200: {
            items: 5
          },
        	1630: {
            items: 6
          }
		}
    });
	brandsowlrtl.owlCarousel({
        items : 6 , //10 items above 1000px browser width
		dots: false,
        loop: false,
		nav: true,
  		autoplay:true,
        autoplaySpeed:1500,
      	autoplayHoverPause: true,
		rtl: true,
		responsive: {
          320: {
            items: 2
          },
          544: {
            items: 3
          },
          992: {
            items: 4
          },
        	1200: {
            items: 5
          },
        	1630: {
            items: 6
          }
	}
    });
   $('.brand-bar').each(function () { 
              if($(this).find('.owl-nav').hasClass('disabled')){
                $(this).find('.customNavigation').hide();
              }else{
                $(this).find('.customNavigation').show();
              }
            });
    $(".brand_next").click(function(){
    	 $(".tt-brand_slider").trigger('next.owl');
    });
    $(".brand_prev").click(function(){
    	 $(".tt-brand_slider").trigger('prev.owl');
    });  
  
  });

jQuery(window).scroll(function () {
  if(jQuery(document).height() > jQuery(window).height()){
    var scroll = jQuery(window).scrollTop();
    if (scroll > 100) {
        jQuery("#GotoTop").fadeIn();
    } else {
        jQuery("#GotoTop").fadeOut();
    }
  }
});
 
function responsiveMenu(){
  if(jQuery(window).width() < 992) {    
    jQuery(".Site-navigation").insertAfter( ".nav-toggle" );
    jQuery('.sub-nav__dropdown').css('display','none');
    
    
   /* jQuery(".tt_menus_ul li  .mobile-nav__sublist-trigger").unbind('click');
        jQuery(".tt_menus_ul  li .mobile-nav__sublist-trigger").on("click", function(evt){
          evt.preventDefault();
             
            if(jQuery(this).parent().has(".tt_sub_menu_wrap")) {
                evt.preventDefault();
            }
            if(!jQuery(this).hasClass("is-active")) {
                // hide any open menus and remove all other classes
                jQuery(".tt_sub_menu_wrap").slideUp();
                jQuery(".tt_menus_ul  li .mobile-nav__sublist-trigger").removeClass("is-active");
                // open our new menu and add the open class
                jQuery(this).parent().next('.tt_sub_menu_wrap').slideDown();
                jQuery(this).addClass("is-active");
                jQuery(".tt_menus_ul li .tt_sub_menu_wrap").slideDown();
            }
            else if(jQuery(this).hasClass("is-active")) {
                jQuery(this).removeClass("is-active");
  
                jQuery(this).parent().next('.tt_sub_menu_wrap').slideUp();
            }
        });
        jQuery(".tt_menus_ul li .mobile-nav__sublist-trigger").removeClass('is-active');*/
    
  }
  else{
    jQuery(".Site-navigation").appendTo( ".menu_wrapper" );  	 
  } 

  if(jQuery(window).width() < 992) {
    $('.header_1 #shopify-section-TT-mega_menu').appendTo('.menu-bar .ttresponsive_menu');	
    $('.header_1 .header-right').insertAfter('.myaccount');
    $('.footer-wrap .footer-column.dwld').appendTo('.footer-wrap .text-left.grid');
  }
  else{
    $('.header_1 #shopify-section-TT-mega_menu').prependTo('.menu-bar .topmenu');
    $("#tt-megamenu .tt_menus_ul .header-right-cms").insertBefore('.full-header .header-middle');
    $('#tt-megamenu .tt_menus_ul #accessibleNav').appendTo('.topmenu'); 
    $('.header_1 .header-right').insertBefore('.header-left');
    $(".header_1 .myaccount").insertAfter('.header_1 .header-right');
    $('.footer-wrap .footer-column.dwld').insertAfter('.footer-wrap .text-left.grid .footer-column.store-info');
  }
}
jQuery(document).ready(function() {
    responsiveMenu();
  
  jQuery(".product-write-review").on('click',function(e) {
        e.preventDefault();
         $('a[href=\'#tab-2\']').trigger('click');
        jQuery('html, body').animate({
            scrollTop: jQuery(".product_tab_wrapper").offset().top-150
            }, 1000);
    });
});
jQuery(document).load(function() { 
   //var menu_wrapper = jQuery('.menu_wrapper.logo_left').height();
  
});
jQuery(window).resize(function() {
    responsiveMenu();
   var w_width = $(window).width();
  $('.slider-content-main-wrap').css('width',w_width);
});


function footerToggle() {
  
    if(jQuery( window ).width() < 992) { 
      if($('.left-sidebar-menu').length > 0){
        jQuery('.left-sidebar-menu').appendTo('.ttresponsive_menu');
        jQuery('.header-right').appendTo('.ttresponsive_menu');

        jQuery(".ttresponsive_menu h4.widget-title").unbind("click");
        jQuery(".ttresponsive_menu  h4.widget-title").on('click',function() {
          jQuery(this).parent().toggleClass('active').children(':nth-child(2)').slideToggle( "fast" );
        }); 
      }else{

        jQuery('nav#menu .nav-menu-wrapper').appendTo('.ttresponsive_menu');
        jQuery(".nav-menu-wrapper h4.widget-title").unbind("click");
        jQuery(".nav-menu-wrapper h4.widget-title").on('click',function() {
          jQuery(this).parent().toggleClass('active').children(':nth-child(2)').slideToggle( "fast" );
        }); 
      }

      jQuery('#column-left').insertAfter('#content');
      if(jQuery('.site-footer').hasClass('fixed_footer'))  {
        jQuery('.page-wrapper').css('margin-bottom','0px');
      }
        jQuery('.left-sidebar.sidebar').insertAfter('.collection_wrapper, .content-wrapper');
        jQuery('.sidebar .sidebar-block').insertAfter('.filter-wrapper');
        jQuery('.both_sidebar .sidebar#column-left .collection_sidebar').insertAfter('.filter-wrapper');
        jQuery(".site-footer .footer-column h5").addClass( "toggle" );
        jQuery(".site-footer .footer-column").children(':nth-child(2)').css( 'display', 'none' );
        jQuery(".site-footer .footer-column.active").children(':nth-child(2)').css( 'display', 'block' );
        jQuery(".site-footer .footer-column h5.toggle").unbind("click");
        jQuery(".site-footer .footer-column h5.toggle").on('click',function() {
            jQuery(this).parent().toggleClass('active').children(':nth-child(2)').slideToggle( "fast" );
        });   
      	jQuery(".site-footer .widget h5").addClass( "toggle" );
        jQuery(".site-footer .widget").children(':nth-child(2)').css( 'display', 'none' );
        jQuery(".site-footer .widget.active").children(':nth-child(2)').css( 'display', 'block' );
        jQuery(".site-footer .widget h5.toggle").unbind("click");
        jQuery(".site-footer .widget h5.toggle").on('click',function() {
            jQuery(this).parent().toggleClass('active').children(':nth-child(2)').slideToggle( "fast" );
        });   
      	jQuery(".sidebar .widget > h4").addClass( "toggle" );
        jQuery(".sidebar .widget ").children(':nth-child(2)').css( 'display', 'none' );
        jQuery(".sidebar .widget.active").children(':nth-child(2)').css( 'display', 'block' );
        jQuery(".sidebar .widget > h4.toggle").unbind("click");
        jQuery(".sidebar .widget > h4.toggle").on('click',function() {
            jQuery(this).parent().toggleClass('active').children(':nth-child(2)').slideToggle( "fast" );
        });   
        jQuery(".sidebar-block .widget > h4").addClass( "toggle" );
        jQuery(".sidebar-block .widget ").children(':nth-child(2)').css( 'display', 'none' );
        jQuery(".sidebar-block .widget.active").children(':nth-child(2)').css( 'display', 'block' );
        jQuery(".sidebar-block .widget > h4.toggle").unbind("click");
        jQuery(".sidebar-block .widget > h4.toggle").on('click',function() {
            jQuery(this).parent().toggleClass('active').children(':nth-child(2)').slideToggle( "fast" );
        });  
    }else{
        if($('.left-sidebar-menu').length > 0){
          jQuery('#accessibleNav').appendTo('.nav-menu-wrapper .navbar-collapse');
        }else{
          jQuery('.ttresponsive_menu .nav-menu-wrapper').appendTo('nav#menu');
        }
      jQuery('.left-sidebar-menu').appendTo('#shopify-section-left-col-menu');
      jQuery('#column-left').insertBefore('#content');
      jQuery('.sidebar .sidebar-block').insertAfter('#shopify-section-left-col-menu');
      jQuery('.both_sidebar .sidebar#column-left .sidebar-block').prependTo('.collection_sidebar');
      jQuery('.section-header .sidebar-block').prependTo('.collection_sidebar');
       if(jQuery('.site-footer').hasClass('fixed_footer'))  {
         var footer_h = jQuery('.site-footer.fixed_footer').height();
         jQuery('.page-wrapper').css('margin-bottom',footer_h+'px');
       }
      jQuery('.left-sidebar.sidebar').insertBefore('.collection_wrapper, .content-wrapper');
        jQuery(".sidebar .widget > h4").unbind("click");
        jQuery(".sidebar .widget > h4").removeClass( "toggle" );
        jQuery(".sidebar .widget").children(':nth-child(2)').css( 'display', 'block' );
      
        jQuery(".site-footer .footer-column h5").unbind("click");
        jQuery(".site-footer .footer-column h5").removeClass( "toggle" );
        jQuery(".site-footer .footer-column").children(':nth-child(2)').css( 'display', 'block' );
      	jQuery(".site-footer .widget h5").unbind("click");
        jQuery(".site-footer .widget h5").removeClass( "toggle" );
        jQuery(".site-footer .widget").children(':nth-child(2)').css( 'display', 'block' );
                
    }
  
}
jQuery(document).ready(function() {
    footerToggle();
   sidebarsticky();  
});
jQuery(window).load(function() {
  var h = $('.design_4 .product-wrapper-owlslider').height();
  $('.design_4 .product-information-inner.tt-scroll').css('min-height', h+"px");
});
jQuery(window).resize(function() {
    footerToggle();
  var h = $('.design_4 .product-wrapper-owlslider').height();
  $('.design_4 .product-information-inner.tt-scroll').css('min-height', h+"px");
});

function splitStr(string,seperator){
    return string.split(seperator);
}

function countDownIni(countdown) {
    $(countdown).each(function() {
        var countdown = $(this);
        var promoperiod;
        if (countdown.attr('data-promoperiod')) {
            promoperiod = new Date().getTime() + parseInt(countdown.attr('data-promoperiod'), 10)
        } else if (countdown.attr('data-countdown')) {
            promoperiod = countdown.attr('data-countdown')
        }
        if (Date.parse(promoperiod) - Date.parse(new Date()) > 0) {
           $(this).addClass('countdown-block');
          $(this).parent().addClass('countdown-enable');
          console.log();
            countdown.countdown(promoperiod, function(event) {
                countdown.html(event.strftime('<span><span class="left-txt">LEFT</span><span>%D</span><span class="time-txt">days</span></span>' + '<span><span>%H</span><span class="time-txt">hours</span></span>' + '<span><span>%M</span><span class="time-txt">min</span></span>' + '<span><span class="second">%S</span><span class="time-txt">sec</span></span>'))
            })
        }
    })
}

function countDownProductIni(countdown) {
			var labels = ['days', 'hours', 'minutes', 'seconds'],
			    $countdown = $(countdown),
			    promoperiod,
			    template = _.template('<div class="time <%= label %>"><span class="count curr top"><%= curr %></span><span class="count next top"><%= next %></span><span class="count next bottom"><%= next %></span><span class="count curr bottom"><%= curr %></span><span class="label"><%= label.length < 6 ? label : label.substr(0, 3)  %></span></div>'),
			    currDate = '00:00:00:00',
			    nextDate = '00:00:00:00';
			if ($countdown.attr('data-promoperiod')) {
				promoperiod = new Date().getTime() + parseInt($countdown.attr('data-promoperiod'), 10);
			}
			if ($countdown.attr('data-countdown')) {
				promoperiod = $countdown.attr('data-countdown');
			}

			function strfobj(str) {
				var parsed = str.split(':'),
				    obj = {};
				labels.forEach(function (label, i) {
					obj[label] = parsed[i];
				});
				return obj;
			}

			function diff(obj1, obj2) {
				var diff = [];
				labels.forEach(function (key) {
					if (obj1[key] !== obj2[key]) {
						diff.push(key);
					}
				});
				return diff;
			}
			var initData = strfobj(currDate);
			labels.forEach(function (label, i) {
				$countdown.append(template({
					curr: initData[label],
					next: initData[label],
					label: label
				}));
			});
			$countdown.countdown(promoperiod, function (event) {
				var newDate = event.strftime('%D:%H:%M:%S'),
				    data;
				if (newDate !== nextDate) {
					currDate = nextDate;
					nextDate = newDate;
					data = {
						'curr': strfobj(currDate),
						'next': strfobj(nextDate)
					};
					diff(data.curr, data.next).forEach(function (label) {
						var selector = '.%s'.replace(/%s/, label),
						    $node = $countdown.find(selector);
						$node.removeClass('flip');
						$node.find('.curr').text(data.curr[label]);
						$node.find('.next').text(data.next[label]);
						_.delay(function ($node) {
							$node.addClass('flip');
						}, 50, $node);
					});
				}
			});
}

function hb_animated_contents() {
  $(".hb-animate-element:in-viewport").each(function (i) {
  var $this = $(this);
  if (!$this.hasClass('hb-in-viewport')) {
  setTimeout(function () {
  $this.addClass('hb-in-viewport');
  }, 180 * i);
  }
  });
}

$(window).scroll(function () {
hb_animated_contents();
});
$(window).load(function () {
hb_animated_contents();
});

$(document).ready(function(){                                                           
              var $desc = $(this).find('.product-description .progress');
              var $qty = $(this).find('.quantity');
              var $pbar = $(this).find('.progress-bar');
              var $progress = $desc;
              var $progressBar = $pbar;
              var $quantity = $qty.html();
              var currentWidth = parseInt($progressBar.css('width'));
              var allowedWidth = parseInt($progress.css('width'));
              var addedWidth = currentWidth + parseInt($quantity);
              if (addedWidth > allowedWidth) {
                addedWidth = allowedWidth;
              }
              var progress = (addedWidth / allowedWidth) * 100;
              $progressBar.animate({width: progress + '%' }, 100);
            });  
     

function sidebarsticky() { 
  if ($(document).width() <= 1199) {
    jQuery('#column-left,.content-right, .no_sidebar .left-sidebar.sidebar,.no_sidebar .right-sidebar.sidebar').theiaStickySidebar({
      additionalMarginBottom: 30,
      additionalMarginTop: 30
    });
  } 
  else if ($(document).width() >= 1200) {
  jQuery('#column-left,.content-right, .no_sidebar .left-sidebar.sidebar,.no_sidebar .right-sidebar.sidebar').theiaStickySidebar({
    additionalMarginBottom: 30,
    additionalMarginTop: 130
  });
  }
}
jQuery(window).resize(function() {
    sidebarsticky();
});
/* responsive accordian menu*/
$(function() {
	var Accordion = function(el, multiple) {
		this.el = el || {};
		this.multiple = multiple || false;

		// Variables privadas
		var links = this.el.find('.mobile-nav__sublist-trigger');
		// Evento
		links.on('click', {el: this.el, multiple: this.multiple}, this.dropdown)
	}

	Accordion.prototype.dropdown = function(e) {
		var $el = e.data.el;
			$this = $(this),
			$next = $this.next();

		$next.slideToggle();
		$this.parent().toggleClass('open');

		if (!e.data.multiple) {
			$el.find('.tt_sub_menu_wrap').not($next).slideUp().parent().removeClass('open');
		};
	}	

	var accordion = new Accordion($('.tt_menus_ul'), false);

	/*
	 * Mobile UX: allow opening submenus by clicking the entire row (icon + texto),
	 * not solo la flecha. Desktop navega normal.
	 */
	$('.tt_menus_ul').off('click.ttRowToggle').on('click.ttRowToggle', '> li.tt_menu_item > a', function(e) {
		// Solo en mobile
		if ($(window).width() >= 992) return;

		var $li   = $(this).parent();
		var $sub  = $li.children('.tt_sub_menu_wrap');

		if (!$sub.length) return; // sin submenú, no hacemos nada

		e.preventDefault();
		e.stopPropagation();

		$sub.stop(true, true).slideToggle();
		$li.toggleClass('open');

		if (!accordion.multiple) {
			$li.siblings('.open').removeClass('open').children('.tt_sub_menu_wrap').stop(true, true).slideUp();
		}
	});
});
